import * as Sentry from '@sentry/react';
import appInfo from '../../package.json';

// Sets up sentry for observability
const sentryInit = () => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_CONNECT_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maxReplayDuration: 10 * 60 * 1000,
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        // show the request payload and response body
        networkDetailAllowUrls: [/https?:\/\/.*/], // Matches any HTTP or HTTPS URL
      }),
    ],
    release: appInfo.version,
    dist: appInfo.version,
    environment: process.env.REACT_APP_ENV || 'dev',
    tracesSampleRate: 0.7,
    replaysSessionSampleRate: 0, // don't sample sessions randomly
    replaysOnErrorSampleRate: 1.0, // sample 100% of errors
  });
};

export default sentryInit;
